import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {EntityTypeLabelPair, IFieldMeta} from '../../interfaces/imetadata';
import {ISignatureFieldEvent} from '../../interfaces/signature';
import { AdcMigrationFieldOptions } from './models';

export type FieldInsertEvent = {
  entity: EntityTypeLabelPair,
  field: IFieldMeta,
  options?: AdcMigrationFieldOptions,
  resolve: (value: (PromiseLike<void> | void)) => void
};

export type SignatureFieldInsertEvent = {
  fieldEvent: ISignatureFieldEvent,
  resolve: (value: (PromiseLike<void> | void)) => void
};

@Injectable({ providedIn: 'root' })
export class FieldInsertService {
  private fieldInsertedSubject = new Subject<FieldInsertEvent>();
  private fieldInserted$ = this.fieldInsertedSubject.asObservable();
  private signatureFieldInsertedSubject = new Subject<SignatureFieldInsertEvent>();
  private signatureFieldInserted$ = this.signatureFieldInsertedSubject.asObservable();

  get fieldInsertedEvents(): Observable<FieldInsertEvent> {
    return this.fieldInserted$;
  }

  get signatureFieldInsertedEvents(): Observable<SignatureFieldInsertEvent> {
    return this.signatureFieldInserted$;
  }

  insert(event: FieldInsertEvent): void {
    this.fieldInsertedSubject.next(event);
  }

  insertSignatureField(event: SignatureFieldInsertEvent): void {
    this.signatureFieldInsertedSubject.next(event);
  }
}
